import { createContext, useContext, type ReactNode } from 'react';
import type { SocketFactory, SocketLike } from '../hooks/useConversationSocket';
import { USE_MOCKS } from '../env';
import { createMockSocket } from '../mocks/socket';

/**
 * Tvornica veze uživo. Postoji da ekran razgovora ne poziva `new WebSocket`
 * izravno: mock demo dobiva lažnu sobu, a testovi vlastitu, bez mreže.
 */
export const defaultSocketFactory: SocketFactory = USE_MOCKS
  ? (url) => createMockSocket(url)
  : (url) => new WebSocket(url) as unknown as SocketLike;

const SocketFactoryContext = createContext<SocketFactory>(defaultSocketFactory);

export function SocketFactoryProvider({
  factory,
  children,
}: {
  factory?: SocketFactory;
  children: ReactNode;
}) {
  return (
    <SocketFactoryContext.Provider value={factory ?? defaultSocketFactory}>
      {children}
    </SocketFactoryContext.Provider>
  );
}

export function useSocketFactory(): SocketFactory {
  return useContext(SocketFactoryContext);
}
